"use client";

import { GradeBlobPill } from "@/components/educators/components/GradeBlobPill";
import {
  type EducatorsGradeKey,
  featuredGamesByGrade,
  gradeBlurbs,
} from "@/components/educators/data/featuredGames";
import Link from "next/link";
import { useMemo, useState } from "react";

export function FeaturedGamesByGradeSection() {
  const [selectedGrade, setSelectedGrade] = useState<EducatorsGradeKey>("k2");

  const featuredGames = useMemo(() => {
    return featuredGamesByGrade[selectedGrade];
  }, [selectedGrade]);

  const gradeBlurb = gradeBlurbs[selectedGrade];

  return (
    <section className="pt-16 pb-28 md:pb-32">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-0">
          <h2 className="charlie-kingdom-font text-cta-gold text-5xl md:text-6xl text-center">
            Great games for
          </h2>

          {/* Grade pills (visual only) */}
          <div className="flex items-start gap-0">
            <GradeBlobPill
              label="K-2"
              active={selectedGrade === "k2"}
              onClick={() => setSelectedGrade("k2")}
            />
            <GradeBlobPill
              label="3-5"
              active={selectedGrade === "35"}
              onClick={() => setSelectedGrade("35")}
            />
          </div>
        </div>

        <div className="mt-6 bg-cta-gold rounded-[2.5rem] p-6 pb-8 md:p-8 md:pb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredGames.map((g) => (
              <Link
                key={g.title}
                href={g.href}
                className={`group flex h-full flex-col rounded-[2rem] border-4 border-black overflow-hidden ${
                  g.cardClassName ?? "bg-surface-lavender"
                }`}
              >
                <div className="shrink-0 bg-white">
                  <img
                    src={g.imageSrc}
                    alt=""
                    aria-hidden="true"
                    className="w-full h-44 md:h-48 object-cover"
                  />
                </div>
                <div className="flex flex-1 flex-col bg-surface-lavender px-6 py-5">
                  <p className="text-3xl font-extrabold text-brand-purple-darker">{g.title}</p>
                  <p className="mt-2 text-black font-semibold text-base leading-snug">
                    {g.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          <p className="mt-8 text-black font-semibold text-base md:text-lg leading-relaxed">
            {gradeBlurb}
          </p>
        </div>
      </div>
    </section>
  );
}
